export enum AdditionalHeaders {
  SITE_ID = 'site-id',
}
